import CredibilityMeter from "@/components/base/CredibilityMeter";
import VerdictBadge from "@/components/base/VerdictBadge";
import { getVerdictStyle } from "@/utils/verdict";
import type { GossipItem } from "@/types";

export default function ScoreCard({ item }: { item: GossipItem }) {
  const style = getVerdictStyle(item.verdict);

  return (
    <div className="border border-background-200 rounded-card bg-background-50 overflow-hidden">
      <div className="px-5 py-4 border-b border-background-200 bg-background-100 flex items-center justify-between">
        <h2 className="font-heading text-base font-bold text-foreground-950">可信度评估</h2>
        <VerdictBadge verdict={item.verdict} />
      </div>

      <div className="p-5">
        <CredibilityMeter score={item.credibility} verdict={item.verdict} size="lg" showScale />

        <p className={`mt-4 text-xs leading-relaxed rounded-control border p-3 ${style.soft}`}>
          <i className="ri-information-line mr-1"></i>
          {style.note}
        </p>

        <h3 className="mt-6 text-sm font-medium text-foreground-900">四个评估维度</h3>
        <ul className="mt-3 space-y-4">
          {item.assessment.map((dim) => (
            <li key={dim.dimension}>
              <div className="flex items-center justify-between text-xs">
                <span className="text-foreground-700">{dim.dimension}</span>
                <span className={`font-mono-num font-bold ${style.text}`}>{dim.score}</span>
              </div>
              <div className="mt-1.5 h-1.5 rounded-full bg-background-200 overflow-hidden">
                <div
                  className={`h-full rounded-full ${style.bar}`}
                  style={{ width: `${dim.score}%` }}
                ></div>
              </div>
              <p className="mt-1 text-[11px] text-foreground-400">{dim.note}</p>
            </li>
          ))}
        </ul>
      </div>

      <div className="px-5 py-4 border-t border-background-200 bg-background-100">
        <p className="text-[11px] text-foreground-500 leading-relaxed">
          <i className="ri-refresh-line mr-1"></i>
          评分仅针对当前可核验的材料，条目可能随新证据更新。
        </p>
      </div>
    </div>
  );
}